import { useEffect, useCallback, useRef, useState } from 'react'
import { useLeafletContext } from '@react-leaflet/core'
import vectorTileLayer from 'leaflet-vector-tile-layer';
import { getColor } from '../../utils/colormaps';
import { getDates } from '../../utils/stringOperations';
import { calculateTrendSummerMonths, excludeSummerMonths, getMinMaxTime, getRechartsTrendObjects } from '../../utils/trend';






export default function TrendVectorLayer (props) {
    // Explanation https://javascript.plainenglish.io/creating-an-ellipse-in-react-leaflet-72e2c5beff03    

    const context = useLeafletContext()
    const options = {
        style: function (e) {
            return {
                fill: false,
                // fillColor: "red",
                // fillOpacity: 0,
                stroke: true,
                color: props.color,
                weight: 1.5
            }
        }
    };
    const layerRef = useRef() 

    useEffect(() => {
        const container = context.layerContainer || context.map
        layerRef.current = vectorTileLayer(props.url, options);
        layerRef.current.setZIndex(10000)
        container.addLayer(layerRef.current)

        return () => {
            container.removeLayer(layerRef.current)
        }
    }, [])

    // useEffect(() => {
    //     layerRef.current.setOpacity(props.layerSelection.opacity)
    //     // propsRef.current = props
    //   }, [props.layerSelection.opacity])

    return null




}

